// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../index';

export const FilterShapeFragmentDoc = `
    fragment filterShape on CatalogueFilterShapeItem {
  __typename
  shape {
    systemCode
    translation(locale: $locale) {
      name
    }
    icon {
      __typename
      id
      url
    }
  }
  totalResults
}
    `;